import React from 'react';
import PropTypes from 'prop-types';

import CustomFieldIcon from "../form-icon";
import CustomFieldType from "../form-type";
import CustomFieldId from "../form-id";

export default function CustomFieldLeftPanel(props) {

    return (
        <div className="iv-left-column iv-column">
            <CustomFieldIcon type={props.parent.type}/>
            <CustomFieldType type={props.parent.type}/>
            <CustomFieldId customField={props.parent.props.customField}/>

            {props.children}
        </div>
    );
}

CustomFieldLeftPanel.propTypes = {
    parent: PropTypes.shape({
        type: PropTypes.number,
        props: PropTypes.object
    })
}